import React, { useState, useMemo, useCallback } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Box, FormHelperText, Grid, Stack, Typography } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

import { adminSettingLogoSchemas } from "../../../schemas/adminSettingPage";
import { RFHfileInput as RHFFileInputButton } from "../../../components/RFH";
import { getAPIBaseUrl } from "../../../utils/constants";
import { useAssets } from "../../../utils/reactQuery/domainAssets";
import useMutate from "../../../hooks/useMutate";
import { updateTenantLogos } from "../../../sevices/apiSystemSettings";
import Pensil from "../../../styles/svg/pensil.svg";
import EditIcon from '@mui/icons-material/Edit';
import { useQueryClient } from "@tanstack/react-query";
import TenantSiteName from "../../../components/TenantSiteName";
import { CustomButton } from "../../../components/Button/Button";

function BrandingLogo() {
  const queryClient = useQueryClient();

  const methods = useForm({
    resolver: yupResolver(adminSettingLogoSchemas),
  });

  const { mutate, isPending } = useMutate(updateTenantLogos, ["logo"], () => {},
  () => {
    methods.reset();
    queryClient.invalidateQueries({
      queryKey: ["logo"],
    });
  });

  const { watch } = methods;
  const logoBlob = watch("logo");
  const feviconBlob = watch("favicon");
  const apiUrl = getAPIBaseUrl();
  const { logo, icon } = useAssets();

  const handleChangeBrandLogo = useCallback(
    (formData) => {
      mutate(formData);
    },
    [mutate]
  );

  const formValues = methods.watch();

  const isFieldFilled = useCallback(
    (name) => {
      return (
        formValues[name] !== undefined &&
        formValues[name] !== "" &&
        formValues[name] !== null
      );
    },
    [formValues]
  );

  return (
    <>
      <FormProvider {...methods}>
        <div className="mt-32 form-section  ">
          <form onSubmit={methods.handleSubmit(handleChangeBrandLogo)}>
            <div>
              <Typography className="setting-heading mb-4 ml-0">
                Branding
              </Typography>
              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <div className="flex-grow-1">
                    <Typography>Logo</Typography>
                    <Stack direction="row" className="branding-cont">
                      <Stack className="branding-icon-cont">
                        {logo || logoBlob ? (
                          <img
                            src={
                              logoBlob
                                ? URL.createObjectURL(logoBlob)
                                : `${apiUrl}/${logo}`
                            }
                            alt="logo"
                          />
                        ) : (
                          <TenantSiteName />
                        )}
                        {/* {!logo ? (
                          ""
                        ) : (
                          <Box className="hover-button">
                            <RHFFileInputButton
                              name="logo"
                              label=""
                              showError={false}
                              startIcon={<CloudUploadIcon />}
                              accept="image/*"
                            ></RHFFileInputButton>
                          </Box>
                        )} */}
                      </Stack>
                      <div className="logos-pensil">
                        <RHFFileInputButton
                          name="logo"
                          label=""
                          showError={false}
                          accept="image/*"
                        >
                          <img src={Pensil} className="cursor-pointer" />
                        </RHFFileInputButton>
                      </div>
                    </Stack>
                  </div>
                  <div className="mt-1">
                    {methods.formState.errors.logo && (
                      <FormHelperText error={true}>
                        {methods.formState.errors.logo.message}
                      </FormHelperText>
                    )}
                    <Typography className="logo-note">
                      Please upload image size less than 200KB.
                    </Typography>
                    <div>
                      <CustomButton
                        variant="contained"
                        type="submit"
                        sx={{ padding: "8px 32px" }}
                        className="theme-bg-color"
                        disabled={isPending || !isFieldFilled("logo")}
                      >
                        Save
                      </CustomButton>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={12} md={4}>
                  <div className="flex-grow-1">
                    <Typography>Favicon</Typography>
                    <Stack direction="row" className="branding-fav-cont">
                      <Stack className="branding-favicon-cont">
                        <img
                          src={
                            feviconBlob
                              ? URL.createObjectURL(feviconBlob)
                              : `${apiUrl}/${icon}`
                          }
                          alt="logo"
                        />
                      </Stack>
                      <div className="logos-pensil">
                        <RHFFileInputButton
                          name="favicon"
                          label=""
                          showError={false}
                          accept="image/*"
                        >
                          <img src={Pensil} className="cursor-pointer" />
                        </RHFFileInputButton>
                      </div>
                    </Stack>
                  </div>
                  <div className="mt-1">
                    {methods.formState.errors.favicon && (
                      <FormHelperText error={true}>
                        {methods.formState.errors.favicon.message}
                      </FormHelperText>
                    )}
                    <Typography className="logo-note">
                      Upload a 30x30 pixel ICO,PNG to display in browser tab.{" "}
                    </Typography>
                    <div>
                      <CustomButton
                        variant="contained"
                        type="submit"
                        sx={{ padding: "8px 32px" }}
                        className="theme-bg-color"
                        disabled={isPending || !isFieldFilled("favicon")}
                      >
                        Save
                      </CustomButton>
                    </div>
                  </div>
                </Grid>
              </Grid>
            </div>
          </form>
        </div>
      </FormProvider>
    </>
  );
}

export default React.memo(BrandingLogo);
